import React, { ContextType, FC, useState } from 'react';

const initialState = {
  chapters: [],
  activeChapter: {},
  mainData: {},
  scrollY: 0,
};

const GlobalContext = React.createContext<ContextType<any>>(initialState);

export const GlobalProvider: FC = ({ children }: any) => {
  const [globalState, setGlobalState] = useState(initialState);
  return (
    <GlobalContext.Provider value={[globalState, setGlobalState]}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContext;
